import * as React from "react";
const IconThumbUp = ({ fill = "#212A3D", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "1em"}
    height="1em"
    fill={fill}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15.264 20a1 1 0 0 0 .894-.553l3.5-7A1 1 0 0 0 18.764 11H12a1 1 0 1 1 0-2h1V5a1 1 0 0 0-1-1 4.6 4.6 0 0 1-.776 2.466L8 11.303v7.916l3.004.751q.119.03.242.03zM6 19v-8H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1zM7.131 9l2.43-3.643c.286-.43.439-.936.439-1.452C10 2.853 10.853 2 11.905 2H12a3 3 0 0 1 3 3v4h3.764c2.23 0 3.68 2.347 2.683 4.342l-3.5 7A3 3 0 0 1 15.264 22h-4.018a3 3 0 0 1-.727-.09L6.877 21H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconThumbUp;
